<template>
    <DCard padding>
        <DRow
            class="mb-3"
            align-vertical="end"
        >
            <DCol
                sm="12"
            >
                <DButton
                    id="table-configuration"
                    icon="cog-outline"
                    :label="__('messages.list_configuration')"
                    class="float-end me-3 mt-3"
                    @click="showListViewModal = true"
                />
            </DCol>
        </DRow>
        <DRow>
            <DCol>
                <DTable
                    :items="items"
                    :fields="getFields"
                    :sorter="true"
                    class="table-responsive"
                >
                    <template #allow_login="{item}">
                        <td>{{ item.allow_login ? __('customers.common.yes') : __('customers.common.no') }}</td>
                    </template>
                    <template #support_allowed="{item}">
                        <td>{{ item.support_allowed ? __('customers.common.yes') : __('customers.common.no') }}</td>
                    </template>
                    <template #firstname="{item}">
                        <td v-if="item.customer === true">
                            <Link :href="$route('customers.customers.show', {customer: item.id})">
                                {{ item.firstname }}
                            </Link>
                        </td>
                        <td v-else>
                            <Link :href="$route('customers.customers.contacts.show', {customer: customer.id, contact: item.id})">
                                {{ item.firstname }}
                            </Link>
                        </td>
                    </template>
                    <template #lastname="{item}">
                        <td v-if="item.customer === true">
                            <Link :href="$route('customers.customers.show', {customer: item.id})">
                                {{ item.lastname }}
                            </Link>
                        </td>
                        <td v-else>
                            <Link :href="$route('customers.customers.contacts.show', {customer: customer.id, contact: item.id})">
                                {{ item.lastname }}
                            </Link>
                        </td>
                    </template>
                    <template #company="{item}">
                        <td>
                            <template v-if="item.company">
                                {{ item.company }}
                            </template>
                            <template v-else>
                                {{ __('messages.not_set') }}
                            </template>
                        </td>
                    </template>
                    <template #email_types="{item}">
                        <td>{{ item.email_types }}</td>
                    </template>
                    <template #support_pin="{item}">
                        <td>
                            <template v-if="item.support_pin">
                                {{ item.support_pin }}
                            </template>
                            <template v-else>
                                {{ __('messages.not_set') }}
                            </template>
                        </td>
                    </template>
                    <template #actions="{item}">
                        <td style="display: flex; grid-gap: 5px;">
                            <DButton
                                v-if="item.customer === true"
                                icon="eye"
                                @click="$inertia.get($route('customers.customers.show', {customer: item.id}))"
                            />
                            <DButton
                                v-else
                                icon="eye"
                                @click="$inertia.get($route('customers.customers.contacts.show', {customer: customer.id, contact: item.id}))"
                            />
                            <DDropdown
                                v-if="item.allow_login && item.customer_cloudpit_account_id && item.customer !== true"
                                :id="`actions_dropdown_${item.id}`"
                                :class="'more-actions-button'"
                                :caret="false"
                                icon="dots-horizontal"
                            >
                                <DDropdownItem
                                    :id="`actions_password_reset_${item.id}`"
                                    @click="handlePasswordReset(item.id)"
                                >
                                    {{ __('customers.customers.cloudpit_password_reset') }}
                                </DDropdownItem>
                                <DDropdownItem
                                    :id="`actions_disable_2fa_${item.id}`"
                                    @click="handleDisable2Fa(item.id)"
                                >
                                    {{ __('customers.customers.cloudpit_disable_2fa') }}
                                </DDropdownItem>
                            </DDropdown>
                        </td>
                    </template>
                    <template #address2="{item}">
                        <td>{{ item.address2 ?? '' }}</td>
                    </template>
                    <template #customer_cloudpit_account_id="{item}">
                        <td>{{ item.customer_cloudpit_account_id ?? '' }}</td>
                    </template>
                    <template #region="{item}">
                        <td>{{ item.region ?? '' }}</td>
                    </template>
                    <template #phone="{item}">
                        <td>{{ item.phone ?? '' }}</td>
                    </template>
                    <template #address1="{item}">
                        <td>{{ item.address1 ?? '' }}</td>
                    </template>
                    <template #postal_code="{item}">
                        <td>{{ item.postal_code ?? '' }}</td>
                    </template>
                    <template #city="{item}">
                        <td>{{ item.city ?? '' }}</td>
                    </template>
                    <template #country_code="{item}">
                        <td>{{ item.country_code ?? '' }}</td>
                    </template>
                    <template #prefix_title="{item}">
                        <td>{{ item.prefix_title ?? '' }}</td>
                    </template>
                    <template #postfix_title="{item}">
                        <td>{{ item.postfix_title ?? '' }}</td>
                    </template>
                    <template #comment="{item}">
                        <td>{{ item.comment ?? '' }}</td>
                    </template>
                    <template #birthdate="{item}">
                        <td>{{ item.birthdate ?? '' }}</td>
                    </template>
                    <template #telemarketing="{item}">
                        <td>{{ item.telemarketing ? __('customers.common.yes') : __('customers.common.no') }}</td>
                    </template>
                </DTable>
            </DCol>
        </DRow>
        <ResetPasswordModal
            :show-modal="showPasswordResetModal"
            @confirm="resetPassword"
            @close="showPasswordResetModal=false"
        />
        <Disable2FAModal
            :show-modal="showDisable2FaModal"
            @confirm="disable2Fa"
            @close="showDisable2FaModal=false"
        />
        <DFabs>
            <s-s-o-fab
                :customer="customer"
                @open-modal="showCreateCloudpitCustomerModal = true"
                @close-modal="showCreateCloudpitCustomerModal = false"
            />
            <!--            <DFab-->
        <!--                v-if="userPermissions.includes('customer.edit')"-->
        <!--                icon="plus"-->
        <!--                :label="__('customers.contacts.add')"-->
        <!--                @click="$inertia.get($route('customers.customers.contacts.create', {customer: customer.id}))"-->
        <!--            />-->
        </DFabs>
        <CreateCloudPitCustomerModal
            :customer="customer"
            :show-modal="showCreateCloudpitCustomerModal"
            @close-modal="showCreateCloudpitCustomerModal = false"
        />
        <ListViewModal
            v-if="showListViewModal"
            :show-modal="showListViewModal"
            :user-list-view="listView"
            @close-modal="showListViewModal = false"
        />
    </DCard>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'
import SSOFab from '~@/Components/Customers/SSOFab'
import CreateCloudPitCustomerModal from '~@/Components/Customers/CreateCloudPitCustomerModal'
import ResetPasswordModal from '~@/Components/Customers/ResetPasswordConfirmationModal.vue'
import Disable2FAModal from '~@/Components/Customers/Disable2FAConfirmationModal.vue'
import ListViewModal from '~@/Components/ListView/ListViewModal'

export default {
    name: 'CustomerContactIndex',
    components: { CreateCloudPitCustomerModal, SSOFab, ResetPasswordModal, Disable2FAModal, ListViewModal },
    layout: [App, CustomerBase],
    props: {
        contacts: {
            type: Array,
            default: () => { return [] }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        listView: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data () {
        return {
            showCreateCloudpitCustomerModal: false,
            showPasswordResetModal: false,
            selectedContact: null,
            showDisable2FaModal: false,
            showListViewModal: false
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        },
        items () {
            // First item is always customer OCN-7709
            let emailTypes = this.__('customers.contacts.invoice') + ', ' + this.__('customers.contacts.tech') + ', ' + this.__('customers.contacts.contract')
            if (this.customer.newsletter_marketing === true) {
                emailTypes += ', ' + this.__('customers.contacts.newsletter')
            }

            const items = [
                Object.assign({
                    id: this.customer.id,
                    firstname: this.customer.firstname,
                    lastname: this.customer.lastname,
                    email: this.customer.email,
                    company: this.customer.company,
                    phone: this.customer.phone,
                    address1: this.customer.address1,
                    address2: this.customer.address2,
                    postal_code: this.customer.postal_code,
                    city: this.customer.city,
                    birthdate: this.customer.birthdate,
                    country_code: this.customer.country_code,
                    email_newsletter: this.customer.newsletter_marketing,
                    email_invoice: true,
                    email_tech: true,
                    email_contract: true,
                    allow_login: true,
                    support_allowed: true,
                    support_pin: null,
                    customer_cloudpit_account_id: this.customer.cloudpit_account_id,
                    function: '',
                    email_types: emailTypes,
                    contact_categories: ['administration', 'technical', 'billing'],
                    customer: true,
                    telemarketing: this.customer.telemarketing
                }, { _classes: 'customer-row' })
            ]

            for (const contact of this.contacts) {
                if (contact.active === false) {
                    Object.assign(contact, { _classes: 'table-selected' })
                    items.push(contact)
                } else {
                    items.push(contact)
                }
            }

            return items
        },
        getFields () {
            const availableList = []

            this.listView.forEach((item) => {
                if (item.show_column === true) {
                    availableList.push({
                        key: item.column,
                        label: item.column !== 'actions' && item.column !== 'icon' ? this.__('settings.list_view.' + item.list + '.' + item.column) : '',
                        sorter: item.sort_column_enabled,
                        _style: item.width !== null ? { minWidth: item.width + 'px', maxWidth: item.width + 'px' } : {}
                    })
                }
            })

            return availableList
        }
    },
    methods: {
        handlePasswordReset (contact) {
            this.showPasswordResetModal = true
            this.selectedContact = contact
        },
        handleDisable2Fa (contact) {
            this.showDisable2FaModal = true
            this.selectedContact = contact
        },
        resetPassword () {
            this.$inertia.get(
                this.$route('customers.customers.contacts.reset-cloudpit-password',
                    { contact: this.selectedContact }
                )
            )
        },
        disable2Fa () {
            this.$inertia.get(
                this.$route('customers.customers.contacts.deactivate-2fa',
                    { contact: this.selectedContact }
                )
            )
        },
        customerContractsUrl (item, contractId) {
            return this.$route('customers.customers.contracts.index', {
                customer: item.customer_id,
                contract: contractId
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.more-actions-button {
    background: var(--colorSecondary);
    color: var(--colorSecondaryText);
    border-radius: 5px;
}
.more-actions-button:hover {
    background: var(--colorSecondaryHover);
}
.more-actions-button:active {
    background: var(--colorSecondaryActive);
}
.fulfillment-requests {
    .c-multi-select-options {
        width: auto !important;
    }
}
</style>

<style lang="scss">
.customer-row {
    font-weight: bold;
}
</style>
